const getHoverImage = (colorsObj, color, fabric = null, category = "other") => {
    if (fabric) {
        const fabricColor = colorsObj[color]?.fabricColors?.find(
            (variant) => variant.fabricName === fabric && variant.categoryType === category,
        );
        if (fabricColor) {
            return fabricColor.image; 
        }
    }
    return colorsObj[color]?.image || undefined;
};

export default getHoverImage;
